import React  from 'react';

const DeletedMessage = () => {
    return (
        <div className="groupchat-message -empty">
        </div>
    )
}

const Message = (props) => {

    const {message, auth, isAdmin, blocked} = props;

    // If Message Deleted
    if(!message) return (<DeletedMessage />)

    // If User that posted is now blocked
    let isBlockedMessage = false;

    if(blocked){
        Object.keys(blocked).map(key => {
            if(!blocked[key]) return;
            if(blocked[key].ip === message.ip){
                isBlockedMessage = key;
            } else {
                return false;
            }
        });
    }

    let classes = 'groupchat-message';
    let showControls = false;

    if(message.ip === auth.ip) {
        classes += ' mychat';
        showControls = true;
    }

    if(isAdmin) showControls = true;

    const toDate = (msg) => {
        if(!msg.createdAt) return;
        let now = parseInt(new Date().getTime()/1000);
        let dif = now - msg.createdAt.seconds;
        let minutes = parseInt(dif/60);
        if(minutes < 1) return 'just now';
        if(minutes === 1) return '1 minute ago';
        if(minutes < 60) return minutes + ' minutes ago';
        let hours = parseInt(minutes/60);
        if(hours === 1) return '1 hour ago';
        if(minutes < 1440) return parseInt(minutes/60) + ' hours ago';
        return parseInt(minutes/1440) + ' days ago';
    }

    const handleDelete = (e) => {
        e.preventDefault();
        props.onDelete(props.id)
    }

    const handleBlockUser = (e) => {
        e.preventDefault();
        props.onBlock(message.ip);
    } 

    const handleUnblockUser = (e) => {
        e.preventDefault();
        props.onUnblock(isBlockedMessage);
    } 

    const messageBody = (isBlockedMessage) ? 'message blocked by admin' : message.m;

    let messageClass = 'groupchat-message-text';

    messageClass += (isBlockedMessage || messageBody === 'deleted') ? ' -deleted' : '';


    return (
        <div className={classes}>
            <div className="user">
                <span className="avatar"></span>
            </div>
            <div className={messageClass}>
                <div className="details">
                    <span className="username">{message.un}</span>
                    <span className="when">{toDate(message)}</span>
                </div>
                <div className="bubble">{messageBody}</div>
                {showControls && (
                    <div className="controls">
                        <a href="#" onClick={handleDelete}><span className="icon icon-trash"></span></a>
                        {isAdmin && !isBlockedMessage && (
                            <a href="#" onClick={handleBlockUser}>block</a>
                        )}
                        {isAdmin && isBlockedMessage && (
                            <a href="#" onClick={handleUnblockUser}>unblock</a>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default Message;